export default "__VITE_ASSET__Ckx4Zzwi__"